import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginType } from '../../models/LoginType';

export interface LoginData { 
    loginType: LoginType | null; 
    npub: string | null; 
    email: string | null; 
    otpId: string 
}

const initialState: LoginData = {
  loginType: null,
  npub: '',
  email: '',
  otpId: '',
};

// Slice
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setDataLogin: (state, action: PayloadAction<LoginData>) => {
        state.loginType = action.payload.loginType;
        if(action.payload.npub) {
            state.npub = action.payload.npub;
        }
        if(action.payload.email) {
            state.email = action.payload.email;
        }
        state.otpId = action.payload.otpId;
    },
  }
});

export const { setDataLogin } = loginSlice.actions;
export default loginSlice.reducer; 